export const documentTypeEnum = {
  INBOUND: 'inbound',
  OUTBOUND: 'outbound'
};

export const documentTypeOption = [
  {id: 'inbound', text: '入库'},
  {id: 'outbound', text: '出库'},
];

export const opTypeOption = [
  {id: 'initInbound', text: '期初入库'},
  {id: 'purchaseInbound', text: '采购入库'},
  {id: 'transferInbound', text: '调拨入库'},
  {id: 'transferReturnInbound', text: '调拨补回入库'},
  {id: 'assembleInbound', text: '装配入库'},
  {id: 'checkInbound', text: '盘点入库'},
  {id: 'otherInbound', text: '其它入库'},
  {id: 'transferOutbound', text: '调拨出库'},
  {id: 'assembleOutbound', text: '装配出库'},
  {id: 'checkOutbound', text: '盘点出库'},
  {id: 'otherOutbound', text: '其它出库'},
];

export const opTypeEnum = {
  INIT_INBOUND: 'initInbound',
  PURCHASE_INBOUND: 'purchaseInbound',
  TRANSFER_INBOUND: 'transferInbound',
  ASSEMBLE_INBOUND: 'assembleInbound',
  CHECK_INBOUND: 'checkInbound',
  OTHER_INBOUND: 'otherInbound',
  TRANSFER_OUTBOUND: 'transferOutbound',
  ASSEMBLE_OUTBOUND: 'assembleOutbound',
  CHECK_OUTBOUND: 'checkOutbound',
  OTHER_OUTBOUND: 'otherOutbound',
};
